import React, {useContext} from 'react';
import {FormGroup, Label, Input} from 'reactstrap';

import {fieldStateCtx} from '@/Form/index';

const Radio = ({id, value, label, inline, ...rest}) => {
  const {name, invalid, onChange} = useContext(fieldStateCtx);

  return (
    <FormGroup check inline={inline}>
      <Input
        type='radio'
        id={id}
        name={name}
        value={value}
        invalid={invalid}
        onChange={onChange}
        {...rest}
      />
      <Label check htmlFor={id}>
        {label}
      </Label>
    </FormGroup>
  );
};

export default Radio;
